document.addEventListener('DOMContentLoaded', function() {
    var video = document.getElementById('drawerVideo');
    var options = {
        root: null, // observing relative to viewport; can be a specific element
        rootMargin: '0px',
        threshold: 0.5  // 50% of the video must be visible
    };
    var observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                
              
              const element = document.getElementById("video-popup");
              const style = window.getComputedStyle(element);
              if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
              }else{
                video.muted = false;
                video.play();
              }

            } else {
                video.pause();
                video.muted = true;
            }
        });
    }, options);
    observer.observe(video);
});


document.addEventListener("DOMContentLoaded", function () {
    const container = document.body;
    container.addEventListener('click', function (event) {
        if (event.target.classList.contains('plus') || event.target.classList.contains('minus')) {
            const input = event.target.parentNode.querySelector('.quantity-input');
            let currentValue = parseInt(input.value, 10);

            if (event.target.classList.contains('plus')) {
                input.value = currentValue + 1;
            } else if (event.target.classList.contains('minus')) {
                if (currentValue > 0) {
                    input.value = currentValue - 1;
                }
            }
          triggerInputChange(input);
        }
    });
});

 function triggerInputChange(input) {
        const event = new Event('change', {
            bubbles: true,
            cancelable: true
        });
        input.dispatchEvent(event);
}

window.addEventListener('load', function() {
    var video = document.getElementById('ssVideo');
    video.play();
});





